import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const DepositGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewDeposit === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

DepositGuard.propTypes = {
  children: PropTypes.node,
};

export default DepositGuard;
